import React from 'react';
import { Star, Quote } from 'lucide-react';
import { Card, CardContent } from './ui/card';
import { REVIEWS_PLACEHOLDER } from '../mock';

export const ReviewsSection = () => {
  return (
    <section className="py-28 lg:py-36 bg-gradient-to-b from-gray-50 to-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-brand-green/8 text-brand-green-dark rounded-full text-sm font-semibold mb-6 border border-brand-green/15">
            Kundenbewertungen
          </div>
          <h2 className="text-4xl lg:text-5xl xl:text-6xl font-bold text-gray-900 mb-6 tracking-tight">
            Das sagen unsere Kunden
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto font-normal">
            Überzeugen Sie sich von der Qualität unserer Arbeit
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {REVIEWS_PLACEHOLDER.map((review) => (
            <Card key={review.id} className="border-0 bg-white shadow-modern-lg hover:shadow-2xl transition-all duration-500 card-hover rounded-3xl overflow-hidden relative">
              <CardContent className="p-8">
                <div className="absolute top-6 right-6 opacity-5">
                  <Quote className="w-12 h-12 text-brand-green" />
                </div>
                
                <div className="relative">
                  <div className="flex items-center gap-1 mb-6">
                    {[...Array(review.rating)].map((_, i) => (
                      <Star key={i} className="w-5 h-5 fill-brand-green text-brand-green" />
                    ))}
                  </div>
                  <p className="text-gray-600 mb-8 text-[15px] leading-relaxed">{review.text}</p>
                  <div className="pt-6 border-t border-gray-100">
                    <p className="font-bold text-gray-900 text-base">{review.name}</p>
                    <p className="text-xs text-gray-500 mt-2">{review.source} • {review.date}</p>
                  </div>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        <div className="text-center mt-12">
          <p className="text-xs text-gray-400 italic">
            Hinweis: Platzhalter für echte Bewertungen aus Google und ProvenExpert
          </p>
        </div>
      </div>
    </section>
  );
};